import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Button, EditButton, ImageUploadModal, ViewMediaModal } from "../../components";
import NewBankForm from "./NewBankForm";

function BankDetails({
  parentName,
  title,
  titleSmall,
  showTitle = true,
  showAddButton = false,
  showEditButton = false,
  handleAdd,
  handleEdit,
  handleIdentificationUpload,
  data,
  children,
  childrenLeft,
  disableInputs = false,
  isEditable = false,
  cancelEdit,
  id,
  formId,
  noEdit,
}) {
  const [showForm, setShowForm] = useState(false);
  const [editable, setEditable] = useState(isEditable);
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [showViewMediaModal, setShowViewMediaModal] = useState(false);

  useEffect(() => {
    if (editable) setShowForm(false);
  }, [editable]);

  useEffect(() => {
    if (data && Object.keys(data).length > 0) setShowForm(false);
    else setShowForm(true);
  }, [data]);

  useEffect(() => {
    setEditable(isEditable);
  }, [isEditable]);

  const handleCancelEdit = () => {
    if (cancelEdit) cancelEdit();
    else setEditable(false);
  };

  return (
    <>
      <section className="section_wrapper">
        {showTitle && (
          <div className="section_title_wrapper">
            <h2 className="section_title">
              {title ?? "Bank account details"}
              {titleSmall && <span className="small"> {titleSmall}</span>}
            </h2>
            {showAddButton && !editable && (
              <Button className="ghost" icon="ic:round-add" iconPosition="start" onClick={() => setShowForm(true)}>
                Add new bank account
              </Button>
            )}
            {showEditButton && !editable && (
              <EditButton
                onClick={() => setEditable(true)}
                disabled={disableInputs || !data || !Object.keys(data).length > 0}
              />
            )}
          </div>
        )}
        {editable ? (
          <NewBankForm
            handleSave={handleEdit}
            handleCancel={handleCancelEdit}
            showCancel
            editable
            data={{ ...data }}
            parentName={parentName}
            id={id}
            formId={formId}
          />
        ) : (
          <>
            {showForm && !noEdit && (
              <NewBankForm
                handleSave={handleAdd}
                disableInputs={disableInputs}
                handleCancel={() => setShowForm(false)}
                showCancel={false}
                id={id}
                formId={formId}
              />
            )}
            {((data && Object.keys(data).length > 0) || noEdit) && (
              <div className="section grid_3">
                <div className="column">
                  {childrenLeft && children}
                  <div className="row">
                    <span className="label">{parentName} name (as per bank)</span>
                    <span className="value">{data?.name_in_bank}</span>
                  </div>
                  <div className="row">
                    <span className="label">Bank name</span>
                    <span className="value">{data?.bank_name}</span>
                  </div>
                  <div className="row">
                    <span className="label">Type of account</span>
                    <span className="value">{data?.bank_account_type}</span>
                  </div>
                  {!childrenLeft && (
                    <div className="row">
                      <span className="label">Account number</span>
                      <span className="value">{data?.bank_account_number}</span>
                    </div>
                  )}
                </div>
                <div className="vertical_divider"></div>
                <div className="column">
                  {childrenLeft && (
                    <div className="row">
                      <span className="label">Account number</span>
                      <span className="value">{data?.bank_account_number}</span>
                    </div>
                  )}
                  <div className="row">
                    <span className="label">IFSC code</span>
                    <span className="value">{data?.bank_ifsc}</span>
                  </div>
                  <div className="row">
                    <span className="label">Bank Branch</span>
                    <span className="value">{data?.bank_branch}</span>
                  </div>
                  <div className="row">
                    <span className="label">Canceled cheque/Passbook photo</span>
                    {data?.bank_identification_url ? (
                      <Button className="ghost" onClick={() => setShowViewMediaModal(true)} disabled={disableInputs}>
                        preview
                      </Button>
                    ) : (
                      <span className="small gray">No photo uploaded</span>
                    )}
                    <Button className="ghost" onClick={() => setShowImageUploadModal(true)} disabled={disableInputs}>
                      upload
                    </Button>
                  </div>
                  {!childrenLeft && children}
                </div>
              </div>
            )}
          </>
        )}
      </section>

      {showImageUploadModal &&
        createPortal(
          <ImageUploadModal
            title="Upload canceled cheque/Passbook photo"
            handleClose={() => setShowImageUploadModal(false)}
            isVisible={showImageUploadModal}
            handleUpload={handleIdentificationUpload}
          />,
          document.body
        )}

      {showViewMediaModal &&
        createPortal(
          <ViewMediaModal
            isVisible={showViewMediaModal}
            handleClose={() => setShowViewMediaModal(false)}
            url={[data.bank_identification_url]}
            mediaType="image"
            title="Canceled cheque/Passbook photo"
          />,
          document.body
        )}
    </>
  );
}

export default BankDetails;
